export default {
  install (Vue, options) {
    Vue.prototype.$createPrivatePassword = function (id) {
      id = btoa(id)
      var l = id.length
      return id[l - 3] + '' + id[l - 2] + '' + id[0] + '' + id[3] + '' + id[5]
    }
  }
}
